import { useTranslation } from "react-i18next";
import CheckIcon from "../../icons/checkIcon";

const OurVision = () => {
  const { t } = useTranslation();
  return (
    <article className=" bg-[#F9F8FE]  py-10">
      <div className="relative z-10 flex flex-col items-center justify-center w-11/12 h-full gap-2 mx-auto lg:justify-between lg:flex-row ">
        <section className="order-2 space-y-4 lg:order-1">
          <h2 className="text-[32px] font-semibold text-mainBlue">{t("ourVision")}</h2>
          <p className="flex items-center gap-2 text-lg">
            <CheckIcon />
            <span className="max-w-[530px]">{t("weAreWorking")}</span>
          </p>
          <p className="flex items-center gap-2 text-lg">
            <CheckIcon />
            <span className="max-w-[530px]">{t("easiestCustoms")}</span>
          </p>
          <p className="flex items-center gap-2 text-lg">
            <CheckIcon />
            <span className="max-w-[530px]">{t("carryingTasks")}</span>
          </p>
        </section>
        <section className="order-1 lg:order-2">
          <img
            src="/assets/our-vision.png"
            alt="our vision"
            className="w-full h-auto"
          />
        </section>
      </div>
    </article>
  );
};

export default OurVision;
